<script setup lang="ts">
import { storeToRefs } from 'pinia'
import BreadcrumbItem from '~/components/header/BreadcrumbItem.vue'
import { useReferralStore } from '~/stores/referral'

const { isFromReferral } = storeToRefs(useReferralStore())
</script>

<template>
  <nav class="overflow-x-auto flex flex-row scrollbar-hide snap-x">
    <BreadcrumbItem :name="isFromReferral ? 'lead' : 'category'" />
    <BreadcrumbItem name="coverage" />
    <BreadcrumbItem name="options" />
    <BreadcrumbItem name="personal" class="mt-4" />
  </nav>
</template>

<style lang="scss" scoped>
/* For Webkit-based browsers (Chrome, Safari and Opera) */
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

/* For IE, Edge and Firefox */
.scrollbar-hide {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
</style>
